<template>
  <v-card flat color="transparent" height="100%">
    <v-card-text>
      <v-content>
        <Cards />
        <iframe :src="urlConnection" style="height: 0;" v-if="userAccount.id" />
      </v-content>
    </v-card-text>
  </v-card>
</template>

<script>
import Cards from '@/components/Initial/Cards'

export default {
  components: { Cards },
  computed: {
    userAccount () {
      return this.$store.state.Account.user
    },
    urlConnection () {
      // document.cookie = `Token=${getStorage('token')}`;
      return process.env.NODE_ENV === 'development' ? `https://signa.ecargoasp.com.br/asp/LoginAPI.asp?UsuarioId=${this.userAccount.id}` : `/asp/LoginAPI.asp?UsuarioId=${this.userAccount.id}`
    }
  }
}
</script>
